import React, { useEffect } from 'react'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import { decode } from 'shopify-gid'

// Components
import Hero from '../../components/hero'
import ProductCard from '../../components/productCard'
import Pagination from '../../components/pagination'
import SEO from '../../components/seo'
import { Typography } from '@material-ui/core'

// Utils
import { gaProductView } from '../../utils/analytics'

// Styles
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8.75),
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridGap: theme.spacing(3),
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
  },
  bundleCard: {
    [theme.breakpoints.up('md')]: {
      gridColumn: '1/3',
    },
    [theme.breakpoints.up('lg')]: {
      gridColumn: '1/4',
    },
  },
}))

const CollectionPage = (props) => {
  // console.log('👾 CollectionPage > ', props)

  const classes = useStyles()

  const { limit, skip } = props.pageContext
  const {
    title,
    description,
    image,
    products,
    handle,
    fields: { shopifyThemePath },
  } = props.data.collection

  const showPagination = products.length > limit

  const collectionImage = image ? image : null
  const imageAlt = image && image.altText ? image.altText : 'temp alt text'

  const productLoop = (products) => {
    let productsArr = products.map((product, index) => {
      if (index + 1 > skip && index + 1 <= skip + limit) {
        return (
          <ProductCard
            key={product.shopifyId}
            product={product}
            collectionTitle={title}
            collectionPath={shopifyThemePath}
            fromLocation="Collection Page"
          />
        )
      }
    })

    // Remove all "undefined" products from array
    productsArr = productsArr.filter((item) => item !== undefined)

    return productsArr
  }

  useEffect(() => {
    if (typeof window === 'undefined') return
    const gaProducts = products.map((product, i) => {
      const decodedProductId = decode(product.storefrontId)
      const price = product.priceRangeV2.minVariantPrice.amount
      return {
        name: product.title, // Name or ID is required.
        id: decodedProductId.id,
        price: price,
        brand: product.vendor,
        category: product.productType,
        variant: product.variants[0].title,
        list: 'Collection Page',
        position: i,
      }
    })

    gaProductView(gaProducts)
  }, [])

  // console.log('COLLECTION PAGE', limit)
  return (
    <>
      <SEO collection={props.data.collection} shopifyThemePath={shopifyThemePath} />
      {collectionImage ? (
        <Hero title={title} content={description} image={collectionImage} imageAlt={imageAlt} />
      ) : (
        <Container maxWidth="lg">
          <Typography component="h1" variant="h1">
            {title}
          </Typography>
        </Container>
      )}
      <Container className={classes.container} maxWidth="lg">
        {productLoop(products)}
      </Container>
      {showPagination && (
        <Container maxWidth="lg">
          <Pagination {...props.pageContext} />
        </Container>
      )}
    </>
  )
}

export default CollectionPage
